import { AuthApi, Configuration } from '@evimo/client';
import type { LoginRequestDto } from '@evimo/client';
import type { CurrentUser } from '@evimo/types';
import { parsePermissionKeys } from '@evimo/types/enums/permission-key';

import { API_URL } from '~/src/constants/env';

const API_BASE = `${API_URL}`;

const api = new AuthApi(
  new Configuration({
    basePath: API_BASE,
    credentials: 'include', // send/receive cookies
  }),
);

export const AuthService = {
  login: async (data: LoginRequestDto) => {
    await api.loginControllerLogin({ loginRequestDto: data });
  },

  logout: async () => {
    await api.logoutControllerLogout({ credentials: 'include' });
  },

  getCurrentUser: async (): Promise<CurrentUser | null> => {
    try {
      const me = await api.meControllerGetCurrentUser({
        credentials: 'include',
      });
      if (!me?.user) {
        return null;
      }

      return {
        ...me.user,
        organizationId: me.user.organizationId ?? null,
        permissions: parsePermissionKeys(me.user.permissions),
      };
    } catch {
      return null;
    }
  },
};
